"use client";
import React from "react";
import FidelityBee from "./components/FidelityBee";
import WagglePointsSection from "./components/Points";
import EventsList from "./components/events/eventsList";
import PartnersList from "./components/partners";
export default function BuzzCardPage() {
  return (
    <div className="bg-white min-h-screen">
      <main className="relative z-10">
        <FidelityBee />
        <WagglePointsSection />
        <EventsList />
        <PartnersList />
      </main>
    </div>
  );
}
